/* GG29 free-shipping bar. Re-reads the cart whenever anything on the page changes it: the theme's buttons,
   the GG29 Buy page, or an app cart (fetch/XHR calls to /cart/add, /cart/change, /cart/update, /cart/clear). */
if (!customElements.get('gg29-shipping-bar')) {
  customElements.define(
    'gg29-shipping-bar',
    class Gg29ShippingBar extends HTMLElement {
      connectedCallback() {
        const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        this.threshold = Math.round(parseInt(this.dataset.threshold, 10) * rate);
        this.textEl = this.querySelector('.gg29-ship__text');
        this.fill = this.querySelector('.gg29-ship__fill');
        this.render(parseInt(this.dataset.total, 10) || 0, parseInt(this.dataset.count, 10) || 0);

        this.refresh = this.refresh.bind(this);
        window.addEventListener('gg29:cart-changed', this.refresh);
        document.addEventListener('rebuy:cart.change', this.refresh);
        Gg29ShippingBar.watchCartCalls();
        this.placeUnderHeader();
      }

      /* Keep the bar right under the sticky header. */
      placeUnderHeader() {
        const header = document.querySelector('.section-header, .shopify-section-header-sticky');
        const set = () => document.documentElement.style.setProperty('--gg29-header-h', header ? `${header.offsetHeight}px` : '0px');
        set();
        if (header && window.ResizeObserver) new ResizeObserver(set).observe(header);
      }

      static watchCartCalls() {
        if (window.gg29CartWatch) return;
        window.gg29CartWatch = true;
        const isCart = (url) => /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url));
        const notify = () => setTimeout(() => window.dispatchEvent(new Event('gg29:cart-changed')), 50);
        const origFetch = window.fetch;
        window.fetch = function (input, init) {
          const url = typeof input === 'string' ? input : input && input.url;
          const p = origFetch.apply(this, arguments);
          if (isCart(url)) p.then(notify, () => {});
          return p;
        };
        const origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
          if (isCart(url)) this.addEventListener('loadend', notify);
          return origOpen.apply(this, arguments);
        };
      }

      async refresh() {
        try {
          const cart = await (await fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, { headers: { Accept: 'application/json' } })).json();
          this.render(cart.total_price, cart.item_count);
        } catch (e) {}
      }

      money(cents) {
        const format = window.gg29MoneyFormat || '${{amount}}';
        const [a, b] = (cents / 100).toFixed(2).split('.');
        const amount = a.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + b;
        return format
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, a)
          .replace(/\{\{\s*\w+\s*\}\}/, amount)
          .replace(/<[^>]*>/g, '')
          .replace(/\.00(?!\d)/, '');
      }

      render(total, count) {
        this.hidden = this.dataset.hideEmpty === 'true' && count === 0;
        const remaining = Math.max(0, this.threshold - total);
        const done = count > 0 && remaining === 0;
        this.classList.toggle('is-done', done);
        const amount = `<strong>${this.money(this.threshold)}</strong>`;
        let text;
        if (count === 0) text = this.dataset.empty;
        else if (done) text = this.dataset.done;
        else text = this.dataset.progress.replace('[remaining]', `<strong>${this.money(remaining)}</strong>`);
        this.textEl.innerHTML = text.replace('[amount]', amount);
        this.fill.style.width = `${Math.min(100, (total / this.threshold) * 100)}%`;
      }
    }
  );
}
